import { useEffect, useRef, useState } from "react";

/**
 * Wraps content with a subtle fade-up animation triggered when it enters the viewport.
 * Uses the .reveal / .reveal.in-view CSS defined in index.css.
 */
export default function Reveal({ children, delay = 0, as: Tag = "div", className = "", testid }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { threshold: 0.05, rootMargin: "0px 0px 0px 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      data-testid={testid}
      className={`reveal ${inView ? "in-view" : ""} ${className}`}
      style={{ animationDelay: `${Math.round(delay * 0.4)}ms` }}
    >
      {children}
    </Tag>
  );
}
